module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Health"
  }, [_c('h1', [_vm._v("タイジューケー")]), _vm._v(" "), _c('md-field', [_c('label', [_vm._v("ニュウリョク")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.weight),
      callback: function($$v) {
        _vm.weight = $$v
      },
      expression: "weight"
    }
  })], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.pushData()
      }
    }
  }, [_vm._v("トーロク")]), _vm._v(" "), _c('vue-chart', {
    attrs: {
      "type": "line",
      "data": _vm.chartData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ede0de5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Health.vue
// module id = 481
// module chunks = 1